
/* styles */
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-764010b6!postcss-loader!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NavItem.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./NavItem.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-764010b6!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./NavItem.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared-components/Navigation/NavItem.vue
// module id = 248
// module chunks = 0